import { BRAND_NAME } from "@/helpers/brand";

export const paymentElementAppearance = {
  variables: {
    borderRadius: "12px",
  },
  rules: {
    ".RadioIcon": {
      width: "20px",
    },
    ".AccordionItem": {
      fontSize: "16px",
      padding: "16px",
      color: "#333",
    },
  },
};

const neoAccordionConfig = {
  type: "accordion",
  radios: true,
  defaultCollapsed: true,
  spacedAccordionItems: false,
};

const titanAccordionConfig = {
  type: "accordion",
  radios: true,
  defaultCollapsed: false,
  spacedAccordionItems: false,
};

const commonPaymentElementConfig = {
  fields: {
    billingDetails: {
      address: "if_required",
      email: "auto",
      name: "auto",
      phone: "auto",
    },
  },
  wallets: {
    applePay: "auto",
    googlePay: "auto",
    link: "never",
  },
};

export const neoPaymentElementConfig = {
  layout: neoAccordionConfig,
  business: { name: BRAND_NAME.NEO },
  ...commonPaymentElementConfig,
};

export const titanPaymentElementConfig = {
  layout: titanAccordionConfig,
  business: { name: BRAND_NAME.TITAN },
  ...commonPaymentElementConfig,
};
